import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";
import "./progressiveloader.scss";

const ProgressiveLoader = (props) => {
  const { loader } = props;

  return (
    <Backdrop
      sx={{
        color: "#fff",
        // zIndex: (theme) => theme.zIndex.drawer + 1,
        zIndex: 500,
      }}
      open={loader}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "2rem",
        }}
        className="loader-box"
      >
        <CircularProgress size={64} style={{ color: "#FFF" }} />
      </Box>
    </Backdrop>
  );
};

export default ProgressiveLoader;
